import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Params4Post } from '../models/General/Params4Post';
import { ReuseTabService } from '../reuse-tab';
import { LocalStorageService } from './local-storage.service';
import { MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    public showLoader = { value: false };// để hiển thị cái loading khi mà load tải báo cáo hoặc tải file excel
    public dialogMobile: boolean;
    public lang0: string = "";
    public lang1: string = "";
    public lang2: string = "";
    public demo: boolean;
    public fromDate: Date;
    public toDate: Date;
    public fromDate2: Date;
    public toDate2: Date;
    public months = {
        1: "Jan",
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
    };
    public monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];
    public options_usd: any = {style: 'currency', currency: 'USD', currencySign: 'accounting', maximumFractionDigits: 2, minimumFractionDigits: 2};
    public options_vnd: any = {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2};

    constructor(private http: HttpClient,
        private reuseTabService: ReuseTabService,
        private localStorageService: LocalStorageService,
        public translate: TranslateService,
    ) {
        if (window.innerWidth <= 1200) {
            this.dialogMobile = true;
        } else {
            this.dialogMobile = false;
        }
        if (localStorage.getItem("langPack") != null && localStorage.getItem("langPack") != undefined && localStorage.getItem("langPack") != "") {
            let langPack: string = this.localStorageService.getItem("langPack");
            let lang: string[] = langPack.split("-");
            this.lang0 = lang[0];
            this.lang1 = lang[1];
            this.lang2 = lang[2];
        }
        this.demo = true;
        if (this.demo) {
            this.fromDate = new Date("Jan 01, 2021");
            this.toDate = new Date("Dec 31, 2021");
            this.fromDate2 = new Date("Jan 01, 2021");
            this.toDate2 = new Date("Dec 31, 2021");
        }
    }

    getLocalStorage(key: string){
        return this.localStorageService.getItem(key);
    }
    //
    getTranlation(string: string): string { // translate from file language
        let result = "";
        this.translate.get(string).subscribe(val => result = val);
        return result;
    }

    showSuccess(messageService: MessageService, message: string) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: message, life: 7000 });
    }

    showSuccessLife(messageService: MessageService, message: string, life: number) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: message, life: life });
    }

    showError(messageService: MessageService, message: string) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: message, life: 10000 });
    }

    showErrorLife(messageService: MessageService, message: string, life: number) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: message, life: life });
    }

    showInfo(messageService: MessageService, message: string) {
        messageService.add({ severity: 'info', summary: 'Info Message', detail: message, life: 7000 });
    }

    showErrorDownloadExcel(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu tải excel file tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request download excel file to server have a error, please send again !"), life: 10000 });
    }

    showErrorLoadReport(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu hiển thị báo cáo tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request show report to server have a error, please send again !"), life: 10000 });
    }

    showSuccessLoadReport(messageService: MessageService) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: (this.getLanguage() == "VN" ? "Lấy báo cáo thành công !" : "Load report successfully !"), life: 7000 });
    }

    showSuccessDownloadExcel(messageService: MessageService) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: (this.getLanguage() == "VN" ? "Tải excel file thành công !" : "Download excel file successfully !"), life: 7000 });
    }

    showErrorRequest(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request to server have a error, please send again !"), life: 10000 });
    }

    showErrorDownloadFile(messageService: MessageService) {
        messageService.add({ severity: 'error', summary: 'Error Message', detail: (this.getLanguage() == "VN" ? "Gửi yêu cầu tải file tới máy chủ bị lỗi, vui lòng thử lại !" : "Send request download file to server have a error, please send again !"), life: 10000 });
    }

    showSuccessDownloadFile(messageService: MessageService) {
        messageService.add({ severity: 'success', summary: 'Success Message', detail: (this.getLanguage() == "VN" ? "Tải file thành công !" : "Download file successfully !"), life: 7000 });
    }

    getUrlCurrent(): string {
        return this.reuseTabService.curUrl;
    }

    removeTab(url: string) {
        this.reuseTabService.close(url);
        return
    }
    getWidthScreen(){
        return window.innerWidth;
    }
    getHeightScreenString(){
        return window.innerHeight.toString() + "px";
    }
    getHeightScreen(){
        return (window.screen.availHeight - (window.outerHeight - window.innerHeight));
    }
    getLanguage(): string {
        return this.localStorageService.getItem("language");
    }

    getData(url: string) {
        return this.http.get(`${environment.apiUrl}/` + url);
    }

    getDataParams(url: string, params: any[]) {
        // params = [[params, value],[params, value]]
        let paramsT = new HttpParams();
        params.forEach(element => {
            paramsT = paramsT.append(`${element[0]}`, `${element[1]}`)
        });
        return this.http.get(`${environment.apiUrl}/` + url, { params: paramsT });
    }

    getDataWithPost(url: string, data) {
        return this.http.post(`${environment.apiUrl}/` + url, data);
    }

    getDataWithPostProgressSpinner(url: string, data: any, destination: any, messageService: MessageService, message: string) {
        this.showLoader.value = true;// pass object to reference
        return this.http.post(`${environment.apiUrl}/` + url, data).subscribe(
            (res: any) => {
                destination.data = res.Data;
            },
            err => {
                this.showError(messageService, this.getLanguage() == "VN" ? "Tải dữ liệu " + message + " bị lỗi, Vui lòng thử lại !" : "Load data " + message + " have a error, please send again !");
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    loadPDFReportProgressSpinner(data?: any, pdfViewerOnDemand?: any, messageService?: MessageService, url?: string) {
        this.showLoader.value = true;// pass object to reference
        return this.http.post(`${environment.apiUrl}/` + url, data, { responseType: 'blob' }).pipe(
            map((result: any) => result))
            .subscribe(
                (res) => {
                    if (res.type == "text/plain") {
                        const data = new Blob([res], { type: 'text/plain' });
                        // data['text']();data.text()
                        data['text']().then(text => {
                            this.showError(messageService, this.getTranlation(text));
                        });
                    }
                    else if (res.type == "application/octet-stream" || res.type == "application/pdf") {
                        pdfViewerOnDemand.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
                        pdfViewerOnDemand.refresh(); // Ask pdf viewer to load/reresh pdf
                        this.showSuccessLoadReport(messageService);
                    }
                    else {
                        this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
                    }
                },
                err => {
                    this.showErrorLoadReport(messageService);
                    this.showLoader.value = false;
                },
                () => {
                    this.showLoader.value = false;
                });
    }

    getPDFReportProgressSpinner(data?: any, report?: any, messageService?: MessageService, url?: string) {
        this.showLoader.value = true;// pass object to reference
        return this.http.post(`${environment.apiUrl}/` + url, data, { responseType: 'blob' }).pipe(
            map((result: any) => result))
            .subscribe(
                (res) => {
                    if (res.type == "text/plain") {
                        const data = new Blob([res], { type: 'text/plain' });
                        // data['text']();data.text()
                        data['text']().then(text => {
                            this.showError(messageService, this.getTranlation(text));
                        });
                    }
                    else if (res.type == "application/pdf") {
                        report.src = res;
                        this.showSuccessLoadReport(messageService);
                    }
                    else {
                        this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
                    }
                },
                err => {
                    this.showErrorLoadReport(messageService);
                    this.showLoader.value = false;
                },
                () => {
                    this.showLoader.value = false;
                });
    }

    loadPDF(data?: any, url?: string): Observable<Blob> {
        return this.http.post(`${environment.apiUrl}/` + url, data, { responseType: 'blob' }).pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    downloadTemplateProgressSpinner(fileName: string, messageService: MessageService, url: string) {
        this.showLoader.value = true;// pass object to reference show Progress Spinner
        return this.http.get(`${environment.apiUrl}/` + url, { responseType: 'blob' }).subscribe(res => {
            if (res.type == "text/plain") {
                const data = new Blob([res], { type: 'text/plain' });
                // data['text']();data.text()
                data['text']().then(text => {
                    this.showError(messageService, this.getTranlation(text));
                });
            }
            else if (res.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                let data = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(data, fileName);
                this.showSuccessDownloadExcel(messageService);
            }
            else {
                this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
            }
        },
            err => {
                this.showErrorDownloadExcel(messageService);
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    downloadFileAttachApproval(fileName: string, messageService: MessageService, url: string, fileID: number) {
        const paramsT = new HttpParams().append('fileID', fileID.toString());
        this.showLoader.value = true;// pass object to reference show Progress Spinner
        return this.http.get(`${environment.apiUrl}/` + url, { params: paramsT, responseType: 'blob' }).subscribe(res => {
            let data = new Blob([res], { type: res.type });
            saveAs(data, fileName);
            this.showSuccessDownloadFile(messageService);
        },
            err => {
                this.showErrorDownloadFile(messageService);
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    downloadExcelProgressSpinner(data: Params4Post, fileName: string, messageService: MessageService, url: string) {
        this.showLoader.value = true;// pass object to reference show Progress Spinner
        return this.http.post(`${environment.apiUrl}/` + url, data, { responseType: 'blob' }).subscribe(res => {
            if (res.type == "text/plain") {
                const data = new Blob([res], { type: 'text/plain' });
                // data['text']();data.text()
                data['text']().then(text => {
                    this.showError(messageService, this.getTranlation(text));
                });
            }
            else if (res.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                let data = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(data, fileName);
                this.showSuccessDownloadExcel(messageService);
            }
            else {
                this.showError(messageService, this.getLanguage() == "VN" ? "Kiểu dữ liệu phản hồi không đúng định dạng" : "The response data type is malformed");
            }
        },
            err => {
                this.showErrorDownloadExcel(messageService);
                this.showLoader.value = false;
            },
            () => {
                this.showLoader.value = false;
            });
    }

    public removeMaskPeriod(value: string) {
        return value.replace("-", "");
    }

    public checkFromToDate(fromDate?: Date, toDate?: Date, messageService?: MessageService): boolean {
        if (fromDate != null && toDate != null && toDate >= fromDate) {
            return true;
        }
        else if (fromDate == null) {
            this.focusInput("fromdate");
            this.showError(messageService, "Please entry from date");
            return false;
        }
        else if (toDate == null) {
            this.focusInput("todate");
            this.showError(messageService, "Please entry to date");
            return false;
        }
        else {
            this.focusInput("fromdate");
            this.showError(messageService, "FromDate <= ToDate");
            return false;
        }
    }

    public checkFromToDate_2(fromDate?: Date, toDate?: Date, fromDate2?: Date, toDate2?: Date, messageService?: MessageService): boolean {
        if (fromDate != null && toDate != null && toDate >= fromDate
            && fromDate2 != null && toDate2 != null && toDate2 >= fromDate2) {
            return true;
        }
        else if (fromDate == null) {
            this.focusInput("fromdate");
            this.showError(messageService, "Please entry from date");
            return false;
        }
        else if (toDate == null) {
            this.focusInput("todate");
            this.showError(messageService, "Please entry to date");
            return false;
        }
        else if (fromDate2 == null) {
            this.focusInput("fromdate2");
            this.showError(messageService, "Please entry from date 2");
            return false;
        }
        else if (toDate2 == null) {
            this.focusInput("todate2");
            this.showError(messageService, "Please entry to date 2");
            return false;
        }
        else if (fromDate > toDate) {
            this.focusInput("fromdate");
            this.showError(messageService, "FromDate have to <= ToDate");
            return false;
        }
        else if (fromDate2 > toDate2) {
            this.focusInput("fromdate2");
            this.showError(messageService, "From Date 2 have to <= To Date 2");
            return false;
        }
        else {
            return false;
        }
    }

    //xử trường hợp làm tròn 10.5 -> 11
    roundss(value: number, digits: number = 0): number {
        if (digits == 0) {
            return Math.round(value + Number.EPSILON);
        } else if (digits == 1) {
            return Math.round((value + Number.EPSILON) * 10) / 10;
        } else if (digits == 2) {
            return Math.round((value + Number.EPSILON) * 100) / 100;
        } else if (digits == 3) {
            return Math.round((value + Number.EPSILON) * 1000) / 1000;
        } else if (digits == 4) {
            return Math.round((value + Number.EPSILON) * 10000) / 10000;
        } else if (digits == 5) {
            return Math.round((value + Number.EPSILON) * 100000) / 100000;
        } else if (digits == 6) {
            return Math.round((value + Number.EPSILON) * 1000000) / 1000000;
        } else if (digits == 7) {
            return Math.round((value + Number.EPSILON) * 10000000) / 10000000;
        }
        else return Math.round((value + Number.EPSILON) * 100000000) / 100000000;
    }

    //Const
    public getHeaderTableCostCenter() {
        return [
            { header: 'frmCostCenter.CostCenterID', field: 'CostCenterID' },
            { header: 'frmCostCenter.CostCenterName', field: 'CostCenterName' },
            { header: 'frmCostCenter.CostCenterNameEN', field: 'CostCenterNameEN' },
            { header: 'frmCostCenter.CostCenterNameKR', field: 'CostCenterNameKR' },
        ];
    }
    public getHeaderTableProfitCenter() {
        return [
            { header: 'Profit Center ID', field: 'ProfitCenterID' },
            { header: 'Profit Center Name', field: 'ProfitCenterName' },
            { header: 'Profit Center Name EN', field: 'ProfitCenterNameEN' },
            { header: 'Profit Center Name KR', field: 'ProfitCenterNameKR' },
        ];
    }
    public getHeaderTableJobCenter() {
        return [
            { header: 'frmJobCenter.JobID', field: 'JobID' },
            { header: 'frmJobCenter.JobName', field: 'JobName' },
            { header: 'frmJobCenter.JobNameEN', field: 'JobNameEN' },
            { header: 'frmJobCenter.JobNameKR', field: 'JobNameKR' },
        ];
    }

    public focusInput(id: string) {
        if (document.getElementById(id))
            document.getElementById(id).focus();
    }

    public focusInputTimeout(id: string) {
        setTimeout(() => {
            if (document.getElementById(id))
                document.getElementById(id).focus()
        }, 100);
    }

    public focusInputTimeout2(id: string, time: number) {
        setTimeout(() => {
            if (document.getElementById(id))
                document.getElementById(id).focus()
        }, time);
    }
    // track by
    public trackByAccountClass = (index, item) => {
        if (item == null) return item;
        else return item.ClassID // O index
    }
    public trackByAccount = (index, item) => {
        if (item == null) return item;
        else return item.Acct // O index
    }
    public trackByItem = (index, item) => {
        if (item == null) return item;
        else return item.ItemID // O index
    }
    public trackByVendors = (index, item) => {
        if (item == null) return item;
        else return item.VendID // O index
    }
    public trackByCustomers = (index, item) => {
        if (item == null) return item;
        else return item.CustID // O index
    }
    public trackByEmployee = (index, item) => {
        if (item == null) return item;
        else return item.EmployeeID // O index
    }
    public trackByTaxs = (index, item) => {
        if (item == null) return item;
        else return item.TaxID // O index
    }
    public trackByBatNbr = (index, item) => {
        if (item == null) return item;
        else return item.BatNbr // O index
    }
    public trackByRefNbr = (index, item) => {
        if (item == null) return item;
        else return item.RefNbr // O index
    }
    public trackByJobCenter = (index, item) => {
        if (item == null) return item;
        else return item.JobID // O index
    }
    public trackByCostCenter = (index, item) => {
        if (item == null) return item;
        else return item.CostCenterID // O index
    }
    public trackByAPVoucher = (index, item) => {
        if (item == null) return item;
        else return item.RefNbr + item.S4Future03  // O index
    }

    //Const Dropdown
    public getNameOfValueFromDropDown(dropdown?: any[], value?: string) {
        if (value == null || value == "") {
            return "";
        }
        else if (dropdown == null || dropdown.length == 0) {
            return value;
        }
        else {
            let dr = dropdown.find(element => element.Code == value);
            if (dr) return dr.Name;
            else return value;
        }
    }

    public getLableFromDropDown(dropdown: any[], value: string) {
        let dr = dropdown.find(element => element.value == value);
        if (dr) return dr.label;
        else return value;
    }

    public getNewDropDown() {
        return [
            { label: '', value: null },
        ];
    }

    public bytesToKB(bytes: number) {
        return this.roundss(bytes / 1000, 2);
    }

    // CP FUNCTION
    public search_recursive(arr: any[], searchKey: any, searchVal: any, resultKey?: any): any {
        let return_arr: any[] = [];
        for (const elem of arr) {
            if (elem[searchKey] == searchVal) {
                if (!(resultKey == undefined || resultKey == null)) {
                    return elem[resultKey];
                }
                return_arr.push(elem);
            }
        }
        return return_arr;
    }

    public convert_ss_MetaYTDData_json(data: any[], metakey: string, type?: string): any {
        const rst_arr = data;

        let search_arr: any[];
        let return_arr: any = {};

        switch (metakey) {
            case "SiteStockByPeriod":
            case "ClassStockByPeriod":
                if(!type || type == 'Value'){
                    search_arr = this.search_recursive(rst_arr, "Axis3Label", "Value");
                }
                else{
                    search_arr = this.search_recursive(rst_arr, "Axis3Label", "Qty");
                }
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value.slice(4)]: item.Axis3Value
                    };
                });
                break;
            case "ItemStockByPeriod":
                if(!type || type == 'Value'){
                    search_arr = this.search_recursive(rst_arr, "Axis3Label", "Value");
                }
                else{
                    search_arr = this.search_recursive(rst_arr, "Axis3Label", "Qty");
                }
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value.slice(4)]: item.Axis3Value,
                        SiteID: item.SiteID, // Add a new key called "siteID"
                    };
                });
                break;
            case "CustomerAmountByPeriod":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value.slice(4)]: item.Axis3Value,
                        CustName: item.CustName,
                    };
                });
                break;
            case "EmployeeAmountByPeriod":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value.slice(4)]: item.Axis3Value,
                    };
                });
                break;
            case "VendorAmountByPeriod":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value.slice(4)]: item.Axis3Value,
                        VendName: item.VendName,
                    };
                });
                break;
            case "S_MonthlyByItem":
            case "S_DailyByItem":
            case "S_ByInvoice":
            case "S_MonthlyByCustomer":
            case "P_MonthlyByItem":
            case "P_MonthlyByVendor":
            case "P_MonthlyByVendor_Inv":
            case "P_DailyByItem":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value]: item.Axis3Value
                    };
                });
                break;
            case "GL_511_YB0":
            case "GL_515_YB0":
            case "GL_531532_YB0":
            case "GL_632_YB0":
            case "GL_635_YB0":
            case "GL_641_YB0":
            case "GL_642_YB0":
            case "GL_711_YB0":
            case "GL_811_YB0":
            case "GL_511_YB1":
            case "GL_515_YB1":
            case "GL_531532_YB1":
            case "GL_632_YB1":
            case "GL_635_YB1":
            case "GL_641_YB1":
            case "GL_642_YB1":
            case "GL_711_YB1":
            case "GL_811_YB1":
            case "GL_511_YB2":
            case "GL_515_YB2":
            case "GL_531532_YB2":
            case "GL_632_YB2":
            case "GL_635_YB2":
            case "GL_641_YB2":
            case "GL_642_YB2":
            case "GL_711_YB2":
            case "GL_811_YB2":
            case "GL_8211_YB0":
            case "GL_8211_YB0":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                search_arr.forEach(item => {
                    return_arr[item.Axis2Label] = {
                        ...return_arr[item.Axis2Label],
                        [item.Axis2Value]: item.Axis3Value
                    };
                });
                break;
            case "CustomerPercentByPeriod":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Percent");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value.slice(4)]: item.Axis3Value
                    };
                });
                break;
            case "CashBook":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value]: item.Axis3Value // [Acct][Period]=Amount
                    };
                });
                break;
            case "CA_GLByPeriod":
            case "VA_GLByPeriod":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Number");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value]: item.Axis3Value // [2021][202101]=00-Number
                    };
                });
                break;
            case "cashbookdaily":
                rst_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value]: item.Axis3Value // [Acct][Date]=Amount
                    };
                });
                break;
            case "S_Top10Vendor":
                    search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                    for (const item of search_arr) {
                        return_arr[item['Axis2Value']] = {
                            VendID: item['Axis1Value'],
                            VendName: item['VendName'],
                            Amount: item['Axis3Value'],
                            Index: item['Axis2Value']
                        };
                    }
                    break;
            case "S_Top10Customer":
                    search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                    for (const item of search_arr) {
                        return_arr[item['Axis2Value']] = {
                            CustID: item['Axis1Value'],
                            CustName: item['CustName'],
                            Amount: item['Axis3Value'],
                            Index: item['Axis2Value']
                        };
                    }
                    break;
            case "DashBoard":
                search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                search_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value.slice(4)]: item.Axis3Value
                    };
                });
                break;
            case "GLBalanceSheet":
                    search_arr = this.search_recursive(rst_arr, "Axis3Label", "Amount");
                    for (const item of search_arr) {
                        return_arr[item['Axis2Value']] = return_arr[item['Axis2Value']] || {};
                        return_arr[item['Axis2Value']][item['Axis1Label']] = {
                            Name: item['Axis1Value'],
                            Amount: item['Axis3Value']
                        };
                    }
                    break;
            default:
                break;
        }

        return return_arr;
    }

    public handle_data(data: any[], datatables_name: string, fromPeriod?: string, toPeriod?: string) {
        let month = 12;
        const year_str = this.getLocalStorage("YearCP");
        if(parseInt(this.getLocalStorage("YearCP")) == new Date().getFullYear()){
            month = new Date().getMonth() + 1;   
        }

        let return_json: object[] = [];
        let rst_arr = data;

        switch (datatables_name.toLowerCase()) {
            case 's_monthlybyitem':
            case 's_monthlybycustomer':
            case 'p_monthlybyitem':
            case 'p_monthlybyvendor':
            case "p_monthlybyvendor_inv":
                for (const [k, item] of Object.entries(rst_arr)) {
                    const row: Record<string, any> = {
                      'id': k,
                      'remain_amt': this.isNaNToZero(item[year_str + '00']) + this.isNaNToZero(item[year_str + '01']) + this.isNaNToZero(item[year_str + '02']) + 
                      this.isNaNToZero(item[year_str + '03']) + this.isNaNToZero(item[year_str + '04']) + this.isNaNToZero(item[year_str + '05']) + 
                      this.isNaNToZero(item[year_str + '06']) + this.isNaNToZero(item[year_str + '07']) + this.isNaNToZero(item[year_str + '08'])
                       + this.isNaNToZero(item[year_str + '09']) + this.isNaNToZero(item[year_str + '10']) + this.isNaNToZero(item[year_str + '11']) + 
                       this.isNaNToZero(item[year_str + '12']),
                    };
                    for (let i = 1; i <= Number(month); i++) {
                      row[String(i).padStart(2, '0')] = this.isNaNToZero(item[year_str + String(i).padStart(2, '0')]) || 0;
                    }
                    return_json.push(row);
                }
                break;
            case 'customeramountbyperiod':
                for (const [k, v] of Object.entries(rst_arr)) {
                    let arr_v = [this.isNaNToZero(v['00']), this.isNaNToZero(v['01']), this.isNaNToZero(v['02']), this.isNaNToZero(v['03']), this.isNaNToZero(v['04']), 
                        this.isNaNToZero(v['05']), this.isNaNToZero(v['06']), this.isNaNToZero(v['07']), this.isNaNToZero(v['08']), this.isNaNToZero(v['09'])
                        , this.isNaNToZero(v['10']), this.isNaNToZero(v['11']), this.isNaNToZero(v['12'])]
                    // if (k && Math.max(...arr_v) > 0) {
                    if (true) {
                        const remain_amt = this.isNaNToZero(v['00']) + this.isNaNToZero(v['01']) + this.isNaNToZero(v['02']) + this.isNaNToZero(v['03']) + this.isNaNToZero(v['04']) + 
                            this.isNaNToZero(v['05']) + this.isNaNToZero(v['06']) + this.isNaNToZero(v['07']) + this.isNaNToZero(v['08']) + this.isNaNToZero(v['09']) + this.isNaNToZero(v['10']) + this.isNaNToZero(v['11']) + this.isNaNToZero(v['12']);
                        const row: any = {
                            id: k,
                            remain_amt,
                        CustName: v['CustName']
                        };
                        let period_amt = 0;
                        for (let i = 0; i <= +month; i++) {
                            period_amt += this.isNaNToZero(v[(i.toString().padStart(2, '0'))]);
                            row[(i.toString().padStart(2, '0'))] = period_amt;
                        }
                        return_json.push(row);
                    }
                }
                break;
            case 'vendoramountbyperiod':
                for (const [k, v] of Object.entries(rst_arr)) {
                    let arr_v = [this.isNaNToZero(v['00']), this.isNaNToZero(v['01']), this.isNaNToZero(v['02']), this.isNaNToZero(v['03']), this.isNaNToZero(v['04']), 
                        this.isNaNToZero(v['05']), this.isNaNToZero(v['06']), this.isNaNToZero(v['07']), this.isNaNToZero(v['08']), this.isNaNToZero(v['09'])
                        , this.isNaNToZero(v['10']), this.isNaNToZero(v['11']), this.isNaNToZero(v['12'])]
                    // if (k && Math.max(...arr_v) > 0) {
                    if (true) {
                        const remain_amt = this.isNaNToZero(v['00']) + this.isNaNToZero(v['01']) + this.isNaNToZero(v['02']) + this.isNaNToZero(v['03']) + this.isNaNToZero(v['04']) + 
                            this.isNaNToZero(v['05']) + this.isNaNToZero(v['06']) + this.isNaNToZero(v['07']) + this.isNaNToZero(v['08']) + this.isNaNToZero(v['09']) + this.isNaNToZero(v['10']) + this.isNaNToZero(v['11']) + this.isNaNToZero(v['12']);
                        const row: any = {
                            id: k,
                            remain_amt,
                        VendName: v['VendName']
                        };
                        let period_amt = 0;
                        for (let i = 0; i <= +month; i++) {
                            period_amt += this.isNaNToZero(v[(i.toString().padStart(2, '0'))]);
                            row[(i.toString().padStart(2, '0'))] = period_amt;
                        }
                        return_json.push(row);
                    }
                }
                break;
            case 'employeeamountbyperiod':
            case 'sitestockbyperiod':
            case 'classstockbyperiod':
                for (const [k, v] of Object.entries(rst_arr)) {
                    let arr_v = Object.keys( v ).map(function ( key ) { return v[key]; });
                    // if (k && Math.max(...arr_v) > 0) {
                    if (k) {
                        const remain_amt = this.isNaNToZero(v['00']) + this.isNaNToZero(v['01']) + this.isNaNToZero(v['02']) + this.isNaNToZero(v['03']) + this.isNaNToZero(v['04']) + 
                            this.isNaNToZero(v['05']) + this.isNaNToZero(v['06']) + this.isNaNToZero(v['07']) + this.isNaNToZero(v['08']) + this.isNaNToZero(v['09']) + this.isNaNToZero(v['10']) + this.isNaNToZero(v['11']) + this.isNaNToZero(v['12']);
                        const row: any = {
                        id: k,
                        remain_amt,
                        };
                        let period_amt = 0;
                        for (let i = 0; i <= +month; i++) {
                            period_amt += this.isNaNToZero(v[(i.toString().padStart(2, '0'))]);
                            row[(i.toString().padStart(2, '0'))] = period_amt;
                        }
                        return_json.push(row);
                    }
                }
                break;
            case 'itemstockbyperiod':
                for (const [k, v] of Object.entries(rst_arr)) {
                    //let arr_v = Object.keys( v ).map(function ( key ) { return v[key]; });
                    let arr_v = [this.isNaNToZero(v['00']), this.isNaNToZero(v['01']), this.isNaNToZero(v['02']), this.isNaNToZero(v['03']), this.isNaNToZero(v['04']), 
                        this.isNaNToZero(v['05']), this.isNaNToZero(v['06']), this.isNaNToZero(v['07']), this.isNaNToZero(v['08']), this.isNaNToZero(v['09'])
                        , this.isNaNToZero(v['10']), this.isNaNToZero(v['11']), this.isNaNToZero(v['12'])]
                    // if (k && Math.max(...arr_v) > 0) {
                    if (k) {
                        const remain_amt = this.isNaNToZero(v['00']) + this.isNaNToZero(v['01']) + this.isNaNToZero(v['02']) + this.isNaNToZero(v['03']) + this.isNaNToZero(v['04']) + 
                            this.isNaNToZero(v['05']) + this.isNaNToZero(v['06']) + this.isNaNToZero(v['07']) + this.isNaNToZero(v['08']) + this.isNaNToZero(v['09']) + this.isNaNToZero(v['10']) + this.isNaNToZero(v['11']) + this.isNaNToZero(v['12']);
                        const row: any = {
                            id: k,
                            remain_amt,
                            siteID: v['SiteID']
                        };
                        let period_amt = 0;
                        for (let i = 0; i <= +month; i++) {
                            period_amt += this.isNaNToZero(v[(i.toString().padStart(2, '0'))]);
                            row[(i.toString().padStart(2, '0'))] = period_amt;
                        }
                        return_json.push(row);
                    }
                }
                break;
            case "s_dailybyitem":
            case "p_dailybyitem":
                let period_str = fromPeriod.slice(0, 6);
                let return_arr: any = {};
                rst_arr.forEach(item => {
                    return_arr[item.Axis1Value] = {
                        ...return_arr[item.Axis1Value],
                        [item.Axis2Value]: item.Axis3Value
                    };
                });
                Object.entries(return_arr).forEach(([k, v]) => {
                const row: Record<any, any> = {
                    'id': k,
                    'remain_amt':  this.isNaNToZero(v[period_str + '00']) +  this.isNaNToZero(v[period_str + '01']) +  this.isNaNToZero(v[period_str + '02']) +  this.isNaNToZero(v[period_str + '03']) +
                    this.isNaNToZero(v[period_str + '04']) +  this.isNaNToZero(v[period_str + '05']) +  this.isNaNToZero(v[period_str + '06']) +  this.isNaNToZero(v[period_str + '07']) + 
                    this.isNaNToZero(v[period_str + '08']) +  this.isNaNToZero(v[period_str + '09']) +  this.isNaNToZero(v[period_str + '10']) +  this.isNaNToZero(v[period_str + '11']) +
                    this.isNaNToZero(v[period_str + '12']) +  this.isNaNToZero(v[period_str + '13']) +  this.isNaNToZero(v[period_str + '14']) +  this.isNaNToZero(v[period_str + '15']) +
                    this.isNaNToZero(v[period_str + '16']) +  this.isNaNToZero(v[period_str + '17']) +  this.isNaNToZero(v[period_str + '18']) +  this.isNaNToZero(v[period_str + '19']) + 
                    this.isNaNToZero(v[period_str + '20']) +  this.isNaNToZero(v[period_str + '21']) +  this.isNaNToZero(v[period_str + '22']) +  this.isNaNToZero(v[period_str + '23']) + 
                    this.isNaNToZero(v[period_str + '24']) +  this.isNaNToZero(v[period_str + '25']) +  this.isNaNToZero(v[period_str + '26']) +  this.isNaNToZero(v[period_str + '27']) +  
                    this.isNaNToZero(v[period_str + '28']) +  this.isNaNToZero(v[period_str + '29']) +  this.isNaNToZero(v[period_str + '30']) +  this.isNaNToZero(v[period_str + '31']),
                };
                for(let i = 1; i <= 31; i++) {
                    row[('0' + i).slice(-2)] = this.isNaNToZero(v[period_str + ('0' + i).slice(-2)]) ?? 0;
                }
                return_json.push(row);
                });
                break;                
            default:

        }

        return return_json;
    }

    public isNaNToZero(value){
        return isNaN(Number(value)) ? 0 : Number(value);

    }

    public convertDisplayCurrency(value: number){
        let div = isNaN(Number(localStorage.getItem("sl_currency"))) ? 1 : Number(localStorage.getItem("sl_currency"));
        return value / div;
    }

    public getNumberMetaValueMetaKey(data: any[], metakey: string){
        if(data){
            let obj = data.find(o => o.metakey == metakey);
            if (obj) return this.isNaNToZero(obj.metavalue);
            else return 0;
        }
        else return 0;
    }

    public displayMoney(value, toFixed: number = 2){
        if(localStorage.sl_currency == 1000000){
            return new Intl.NumberFormat('en-US',this.options_vnd).format(Number((Number(value) / Number(localStorage.sl_currency)).toFixed(toFixed))) + 'M';
        }
        else if(localStorage.sl_currency == 1){
            return new Intl.NumberFormat('en-US',this.options_vnd).format(Number((Number(value) / Number(localStorage.sl_currency)).toFixed(toFixed)));
        }
        else{
            return new Intl.NumberFormat('en-US', this.options_usd).format(Number((Number(value) / Number(localStorage.sl_currency)).toFixed(toFixed)));
        }
    }

    public displayMoneyZero(value, toFixed: number = 2){
        if(Number(value) == 0){
            return "-";
        }
        if(localStorage.sl_currency == 1000000){
            return new Intl.NumberFormat('en-US',this.options_vnd).format(Number((Number(value) / Number(localStorage.sl_currency)).toFixed(toFixed))) + 'M';
        }
        else if(localStorage.sl_currency == 1){
            return new Intl.NumberFormat('en-US',this.options_vnd).format(Number((Number(value) / Number(localStorage.sl_currency)).toFixed(toFixed)));
        }
        else{
            return new Intl.NumberFormat('en-US', this.options_usd).format(Number((Number(value) / Number(localStorage.sl_currency)).toFixed(toFixed)));
        }
    }
    
    public formatNumber(value, toFixed: number = 2){
        return Number(value).toFixed(toFixed);
    }

    public abs(value){
        return Math.abs(value);
    }

    // "01" => "1"
    public convertKeys(inputObj) {
        const outputObj = {};
        for (const key in inputObj) {
          const newKey = key.replace(/^0+/, ''); // remove leading zeros
          outputObj[newKey] = inputObj[key];
        }
        return outputObj;
    }

    public ExcelDateToJSDate(date) {
        return new Date(Math.round((date - 25569)*86400*1000));
    }

    postFile(fileToUpload: File,module: string) {
        // let queryParams = new HttpParams();
        // queryParams = queryParams.append("module",data.params1);
        let formData = new FormData(); 
        formData.append('fileKey', fileToUpload,fileToUpload.name);

        //formData.append('module', "GL");
        switch (module) {
            case 'GL': {return this.http.post(`${environment.apiUrl}/api/general/ReadDataGL`, formData); break;}
            case 'AP': {return this.http.post(`${environment.apiUrl}/api/general/ReadDataAP`, formData);break;}
            case 'AR': {return this.http.post(`${environment.apiUrl}/api/general/ReadDataAR`, formData);break;}
            case 'CA': {return this.http.post(`${environment.apiUrl}/api/general/ReadDataCA`, formData);break;}
            case 'Input': {return this.http.post(`${environment.apiUrl}/api/general/ReadDataInput`, formData);break;}
            case 'Output': {return this.http.post(`${environment.apiUrl}/api/general/ReadDataOutput`, formData);break;}
        }
    }

    // public ExcelDateToJSDate(serial) {
    //     var utc_days  = Math.floor(serial - 25569);
    //     var utc_value = utc_days * 86400;                                        
    //     var date_info = new Date(utc_value * 1000);
     
    //     var fractional_day = serial - Math.floor(serial) + 0.0000001;
     
    //     var total_seconds = Math.floor(86400 * fractional_day);
     
    //     var seconds = total_seconds % 60;
     
    //     total_seconds -= seconds;
     
    //     var hours = Math.floor(total_seconds / (60 * 60));
    //     var minutes = Math.floor(total_seconds / 60) % 60;
     
    //     return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    // }
    randomID(){
        // Generate a random integer between 1 and 100,000,000
        var min = 1;
        var max = 1000000000;
        var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomNumber;
    }
}
